import { CSSProperties } from 'react';
import { createPortal } from 'react-dom';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';

type MissingCryptoWalletModalProps = {
  open: boolean;
  onClose: () => void;
  onGoToProfile: () => void;
};

const MissingCryptoWalletModal = ({
  open,
  onClose,
  onGoToProfile
}: MissingCryptoWalletModalProps) => {
  if (!open) return null;

  return createPortal(
    <div style={backdropStyle} onClick={onClose}>
      <div style={modalStyle} onClick={(event) => event.stopPropagation()}>
        <div style={accentGlowStyle} />
        <div style={iconWrapStyle}>
          <CurrencyBitcoinIcon style={{ fontSize: '2rem' }} />
        </div>
        <span style={titleStyle}>Crypto Withdrawal</span>
        <span style={messageStyle}>
          Add a Bitcoin withdrawal address to your account profile before starting a BTC withdrawal.
        </span>
        <div style={actionsStyle}>
          <button type='button' onClick={onGoToProfile} style={primaryBtnStyle}>
            Go to Account Profile
          </button>
          <button type='button' onClick={onClose} style={secondaryBtnStyle}>
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MissingCryptoWalletModal;

const backdropStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  zIndex: 1200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '1rem',
  background:
    'radial-gradient(circle at 50% 32%, rgba(233,140,38,0.16), transparent 28%), rgba(0, 0, 0, 0.76)',
  backdropFilter: 'blur(8px)'
};

const modalStyle: CSSProperties = {
  position: 'relative',
  width: '100%',
  maxWidth: '500px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  padding: '2.2rem 2rem 1.8rem',
  borderRadius: '20px',
  background: 'linear-gradient(180deg, rgba(23, 31, 43, 0.98) 0%, rgba(13, 18, 27, 0.98) 100%)',
  boxShadow:
    '0 28px 80px rgba(0,0,0,0.58), inset 0 1px 0 rgba(255,255,255,0.08), 0 0 0 1px rgba(233,140,38,0.08)',
  border: '1px solid rgba(255,255,255,0.1)',
  textAlign: 'center',
  overflow: 'hidden'
};

const accentGlowStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: '12%',
  right: '12%',
  height: '2px',
  background: 'linear-gradient(90deg, transparent, rgba(233,140,38,0.95), transparent)',
  boxShadow: '0 0 22px rgba(233,140,38,0.7)'
};

const iconWrapStyle: CSSProperties = {
  width: 62,
  height: 62,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '20px',
  color: '#E98C26',
  background: 'linear-gradient(180deg, rgba(233,140,38,0.18), rgba(233,140,38,0.06))',
  border: '1px solid rgba(233,140,38,0.28)',
  boxShadow: '0 14px 32px rgba(233,140,38,0.16)'
};

const titleStyle: CSSProperties = {
  fontSize: 'clamp(1.65rem, 3vw, 2rem)',
  fontWeight: 900,
  color: '#fff'
};

const messageStyle: CSSProperties = {
  maxWidth: '390px',
  fontSize: '0.93rem',
  lineHeight: 1.75,
  color: 'rgba(255,255,255,0.76)'
};

const actionsStyle: CSSProperties = {
  display: 'flex',
  gap: '0.75rem',
  justifyContent: 'center',
  flexWrap: 'wrap',
  width: '100%',
  marginTop: '0.35rem'
};

const primaryBtnStyle: CSSProperties = {
  flex: '1 1 220px',
  maxWidth: '250px',
  padding: '0.95rem 1.15rem',
  border: 'none',
  borderRadius: '13px',
  background: 'linear-gradient(180deg, #F29B2A 0%, #E98C26 100%)',
  color: '#fff',
  fontSize: '0.88rem',
  fontWeight: 800,
  cursor: 'pointer',
  fontFamily: 'inherit'
};

const secondaryBtnStyle: CSSProperties = {
  flex: '1 1 140px',
  maxWidth: '170px',
  padding: '0.95rem 1.15rem',
  border: '1px solid rgba(255,255,255,0.12)',
  borderRadius: '13px',
  background: 'rgba(255,255,255,0.06)',
  color: 'rgba(255,255,255,0.84)',
  fontSize: '0.88rem',
  fontWeight: 800,
  cursor: 'pointer',
  fontFamily: 'inherit'
};
